import { Comments } from "../../../../interfaces/Comments.interface";

export const getRandomEmoji = (comments: Comments[]) => {
  const allUniqueUsedEmojis = Array.from(
    new Set(comments.map((comment) => comment.emoji))
  );

  const emojis = [
    "😢",
    "😂",
    "😭",
    "😪",
    "😥",
    "😰",
    "😅",
    "😓",
    "😩",
    "😫",
    "😨",
    "😱",
    "😠",
    "😤",
    "😷",
    "😎",
    "😴",
    "😵",
    "😲",
    "😟",
    "😦",
    "😧",
    "😈",
    "😮",
    "😬",
    "😐",
    "😕",
    "😯",
    "😶",
    "😇",
    "😏",
    "😑",
    "👲",
    "👳",
    "👮",
    "👷",
    "👶",
    "👩",
    "🙀",
    "😿",
    "😹",
    "😾",
    "👹",
    "👺",
    "🙈",
    "🙉",
    "🙊",
    "💀",
    "👽",
    "💩",
    "🔥",
    "✨",
    "🌟",
    "💫",
    "💥",
    "💢",
    "💦",
    "💧",
    "👂",
    "👀",
    "👃",
    "👅",
    "👄",
    "👍",
    "👌",
    "✊",
    "👋",
    "👐",
    "🙌",
    "🙏",
    "💪",
    "💏",
    "💑",
    "🙆",
    "🙅",
    "💁",
    "🙋",
    "💆",
    "💇",
    "💅",
    "👰",
    "🙎",
    "🙍",
    "🙇",
    "👑",
    "👒",
    "👟",
    "👠",
    "👢",
    "👕",
    "👔",
    "👚",
    "👗",
    "🎽",
    "👘",
    "👜",
    "👝",
    "👛",
    "👓",
    "🎀",
    "💄",
    "💛",
    "💙",
    "💜",
    "💚",
    "💔",
    "💘",
    "💌",
    "💋",
    "💍",
    "💎",
    "💬",
    "💭",
    "🐶",
    "🐱",
    "🐭",
    "🐹",
    "🐰",
    "🐸",
    "🐯",
    "🐨",
    "🐻",
    "🐷",
    "🐽",
    "🐮",
    "🐵",
    "🐒",
    "🐴",
    "🐑",
    "🐘",
    "🐼",
    "🐧",
    "🐦",
    "🐤",
    "🐥",
    "🐙",
    "🐚",
    "🐠",
    "🐟",
    "🐬",
    "🐳",
    "🐋",
    "🐄",
    "🐏",
    "🐅",
    "🐇",
    "🐉",
    "🐓",
    "🐕",
    "🐖",
    "🐁",
    "🐂",
    "🐲",
    "🐡",
    "🐊",
    "🐈",
    "🐩",
    "💐",
    "🌸",
    "🌷",
    "🍀",
    "🌹",
    "🌻",
    "🌺",
    "🍁",
    "🍂",
    "🌿",
    "🌾",
    "🍄",
    "🌵",
    "🌴",
    "🌲",
    "🌳",
    "🌰",
    "🌱",
    "🌕",
    "🌛",
    "🌙",
    "🌍",
    "🌎",
    "🌏",
    "⭐",
    "⛅",
    "🌈",
    "🌊",
    "🎍",
    "💝",
    "🎒",
    "🎏",
    "🎆",
    "🎇",
    "🎐",
    "🎑",
    "🎃",
    "👻",
    "🎅",
    "🎄",
    "🎁",
    "🎋",
    "🎉",
    "🎊",
    "🎈",
    "🎌",
    "🔮",
    "💿",
    "📀",
    "💽",
    "💾",
    "📟",
    "📠",
    "📡",
    "📺",
    "📻",
    "🔊",
    "🔉",
    "🔈",
    "🔇",
    "🔔",
    "🔕",
    "📢",
    "📣",
    "⏳",
    "⌛",
    "⏰",
    "🔎",
    "💡",
    "🔦",
    "🔍",
    "🛁",
    "🛀",
    "🔫",
    "🔪",
    "💊",
    "💉",
    "💰",
    "💳",
    "💸",
    "📌",
    "📎",
    "📒",
    "📚",
    "📛",
    "🔬",
    "🔭",
    "🎨",
    "🎬",
    "🎧",
    "🎲",
    "🎯",
    "🏈",
    "🏀",
    "⚽",
    "⚾",
    "🎾",
    "🍵",
    "🍶",
    "🍼",
    "🍺",
    "🍻",
    "🍸",
    "🍹",
    "🍷",
    "🍴",
    "🍕",
    "🍔",
    "🍟",
    "🍗",
    "🍖",
    "🍝",
    "🍛",
    "🍤",
    "🍱",
    "🍣",
    "🍥",
    "🍙",
    "🍘",
    "🍚",
    "🍜",
    "🍲",
    "🍢",
    "🍡",
    "🍳",
    "🍞",
    "🍩",
    "🍮",
    "🍦",
    "🍨",
    "🍧",
    "🎂",
    "🍰",
    "🍪",
    "🍫",
    "🍬",
    "🍭",
    "🍯",
    "🍎",
    "🍏",
    "🍊",
    "🍋",
    "🍒",
    "🍇",
    "🍉",
    "🍓",
    "🍑",
    "🍈",
    "🍌",
    "🍐",
    "🍍",
    "🍠",
    "🍆",
    "🍅",
    "🌽",
    "🏠",
    "🏡",
    "🏫",
    "🏢",
    "🏣",
    "🏥",
    "🏦",
    "🏪",
    "🏩",
    "🏨",
    "💒",
    "⛪",
    "🏬",
    "🏤",
    "🌇",
    "🌆",
    "🏯",
    "🏰",
    "⛺",
    "🏭",
    "🗾",
    "🗻",
    "🌄",
    "🌅",
    "🌃",
    "🗽",
    "⛲",
    "🚢",
    "⛵",
    "🚤",
    "🚣",
    "🚀",
    "🚞",
    "🚆",
    "🚄",
    "🚅",
    "🚈",
    "🚝",
    "🚋",
    "🚃",
    "🚎",
    "🚌",
    "🚍",
    "🚙",
    "🚘",
    "🚗",
    "🚕",
    "🚖",
    "🚛",
    "🚚",
    "🚨",
    "🚓",
    "🚔",
    "🚒",
    "🚑",
    "🚧",
    "🔰",
    "⛽",
    "🏮",
    "🎰",
    "🎪",
    "🎭",
    "📍",
    "🚩",
    "🚹",
    "🚺",
    "🚾",
    "🚫",
    "💯",
    "🔘",
    "🔗",
    "🔱",
  ];

  const filteredEmojis = emojis.filter(
    (emoji) => !allUniqueUsedEmojis.includes(emoji)
  );

  return filteredEmojis[Math.floor(Math.random() * filteredEmojis.length)];
};
